module.exports = __webpack_public_path__ + "img/Butterfly_00093.262ba693.png";